import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router'
import { Onboardings } from '@/core/enums/onboardings'
import { useOnboarding } from '@/core/hooks/use-onboarding'
import { steps } from '../components/steps'

export const useUsuarioEdicaoOnboarding = () => {
  const { currentUserOnboardingIsSeen, setSteps, setOpen, loading, save } =
    useOnboarding(Onboardings.USUARIO_EDICAO)
  const params = useParams()

  const setNextStepAndOpen = useCallback(() => {
    if (params.id) return
    setSteps([steps(save)[1]])
    setOpen()
  }, [params.id, setSteps, save, setOpen])

  useEffect(() => {
    if (!currentUserOnboardingIsSeen && !loading) {
      // se o usuario estiver editando um usuario existente e não fez o onboarding ainda, carrega todos os steps
      // caso contrario carrega apenas o primeiro, o segundo será carregado dinamicamente ao selecionar opções
      if (params.id) {
        setSteps(steps(save))
      } else {
        setSteps([steps()[0]])
      }
      setOpen()
    }
  }, [currentUserOnboardingIsSeen, loading, params.id, save, setOpen, setSteps])

  return { setNextStepAndOpen }
}
